<template>
  <div :class="componentClassName">
    <div class="m-business-hour-setting-item__activation">
      <a-switch v-model="activated" :label="label" @change="handleActivationChange" />
    </div>
    <div class="m-business-hour-setting-item__options">
      <div class="m-business-hour-setting-item__list-item">
        <label class="m-business-hour-setting-item__options-label">営業時間</label>
      </div>

      <div v-if="periodList.length > 0" class="m-business-hour-setting-item__list">
        <div v-for="(item, index) in periodList" :key="index" class="m-business-hour-setting-item__list-item">
          <div class="m-business-hour-setting-item__list-item-period">
            <a-business-hour-input-field
              :id="convertIndex(index)"
              v-model="periodList[index]"
              :item-index="index"
              :disabled="!activated"
              @remove="handlePeriodRemoveClick"
              @change="handleChange"
            />
          </div>
        </div>
      </div>
      <div class="m-business-hour-setting-item__options-config">
        <div class="m-business-hour-setting-item__add-button">
          <a-button
            v-if="periodList.length < 3"
            :id="'add_business_hours_' + dayOfWeek[label]"
            variant="fill"
            size="small"
            label="営業時間を追加"
            color="primary"
            :inline="true"
            :disabled="!activated || currentIs24hours"
            @click="handleAddPeriodClick"
          />
        </div>
        <!-- 24時間チェックを非表示にするため、以下を一時的にコメントアウト -->
        <!-- <div class="m-business-hour-setting-item__checkbox">
          <a-checkbox v-model="currentIs24hours" label="24時間営業" :disabled="!activated" @change="handleChange" />
        </div> -->
      </div>
      <div class="m-business-hour-setting-item__list-item">
        <label class="m-business-hour-setting-item__options-label">休憩時間</label>
      </div>
      <div v-if="breakTimePeriodList.length > 0" class="m-business-hour-setting-item__list">
        <div v-for="(item, index) in breakTimePeriodList" :key="index" class="m-business-hour-setting-item__list-item">
          <div class="m-business-hour-setting-item__list-item-period">
            <a-business-hour-input-field
              :id="convertIndex(index)"
              v-model="breakTimePeriodList[index]"
              :item-index="index"
              :disabled="!activated"
              @remove="handleBreakTimePeriodRemoveClick"
              @change="handleBreakTimeChange"
            />
          </div>
        </div>
      </div>
      <div class="m-business-hour-setting-item__options-config">
        <div class="m-business-hour-setting-item__add-button">
          <a-button
            v-if="breakTimePeriodList.length < 3"
            :id="'add_break_time_hours_' + dayOfWeek[label]"
            variant="fill"
            size="small"
            label="休憩時間を追加"
            color="primary"
            :inline="true"
            :disabled="!activated || currentIs24hours"
            @click="handleAddBreakTimeClick"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import ASwitch from '@/components/atoms/switch';
// 24時間チェックを非表示にするため、以下を一時的にコメントアウト
// import ACheckbox from '@/components/atoms/checkbox';
import ABusinessHourInputField from '@/components/atoms/business-hour-input-field';
import { cloneDeep } from 'lodash';

export default {
  name: 'm-business-hour-setting-item',
  components: {
    AButton,
    ASwitch,
    // 24時間チェックを非表示にするため、以下を一時的にコメントアウト
    // ACheckbox,
    ABusinessHourInputField,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    itemIndex: {
      type: Number,
      default: 0,
    },
    active: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Boolean,
      default: null,
    },
    // 24時間チェックを非表示にするため、以下を一時的にコメントアウト
    // is24hours: {
    //   type: Boolean,
    //   default: null,
    // },
    periods: {
      type: Array,
      default: null,
    },
    breakTimePeriods: {
      type: Array,
      default: null,
    },
  },
  emits: [
    'activate',
    'deactivate',
    'add',
    'remove',
    'change',
    'breakTimeAdd',
    'breakTimeRemove',
    'breakTimeChange',
    'update:modelValue',
    // 24時間チェックを非表示にするため、以下を一時的にコメントアウト
    // 'update:is24hours',
    'update:periods',
    'update:breakTimePeriods',
  ],
  data() {
    return {
      activated: false,
      // 24時間チェックを非表示にするため、以下を一時的にfalse
      currentIs24hours: false,
      periodList: [],
      breakTimePeriodList: [],
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('m-business-hour-setting-item', this.activated ? 'active' : 'inactive');
      return `${baseClassName} ${this.class}`.trim();
    },
    dayOfWeek() {
      return {
        月曜日: 'monday',
        火曜日: 'tuesday',
        水曜日: 'wednesday',
        木曜日: 'thursday',
        金曜日: 'friday',
        土曜日: 'saturday',
        日曜日: 'sunday',
      };
    },
    isShowBreakTimeAddBtn() {
      return this.breakTimePeriodList.length < 3 && this.periodList.length > 1;
    },
  },
  watch: {
    active(val, oldValue) {
      this.activated = val;
    },
    modelValue(val, oldValue) {
      this.activated = val;
    },
    // 24時間チェックを非表示にするため、以下を一時的にコメントアウト
    // is24hours(val, oldValue) {
    //   this.$emit('update:is24hours', this.currentIs24hours);
    // },
    // currentIs24hours(val, oldValue) {
    //   if (val) {
    //     // clear all existing period
    //     this.periodList.splice(0);
    //   }
    // },
    periods: {
      handler(val) {
        this.setCurrentPeriod(val);
      },
      deep: true,
    },
    breakTimePeriods: {
      handler(val) {
        this.setCurrentBreakTimePeriod(val);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.active) {
      this.activated = this.active;
    }
    if (this.modelValue) {
      this.activated = this.modelValue;
    }
    // 24時間チェックを非表示にするため、以下を一時的にコメントアウト
    // if (this.is24hours !== null) {
    //   this.currentIs24hours = this.is24hours;
    // }
    if (this.periods !== null) {
      this.setCurrentPeriod(this.periods);
    }
    if (this.breakTimePeriods !== null) {
      this.setCurrentBreakTimePeriod(this.breakTimePeriods);
    }
  },
  methods: {
    handleActivationChange(e) {
      const event = e.target.checked ? 'activate' : 'deactivate';
      this.$emit(event, this.itemIndex);
      this.$emit('update:modelValue', this.activated);
      this.$emit('change', e);
    },
    handlePeriodRemoveClick(index) {
      this.periodList.splice(index, 1);
      this.$emit('update:periods', cloneDeep(this.periodList));
      this.$emit('remove', index);
    },
    handleBreakTimePeriodRemoveClick(index) {
      this.breakTimePeriodList.splice(index, 1);
      this.$emit('update:breakTimePeriods', cloneDeep(this.breakTimePeriodList));
      this.$emit('breakTimeRemove', index);
    },
    handleAddPeriodClick() {
      this.periodList.push('');
      this.$emit('update:periods', cloneDeep(this.periodList));
      this.$emit('add');
    },
    handleAddBreakTimeClick() {
      this.breakTimePeriodList.push('');
      this.$emit('update:breakTimePeriods', cloneDeep(this.breakTimePeriodList));
      this.$emit('breakTimeAdd');
    },
    setCurrentPeriod(periods) {
      this.periodList.splice(0);
      periods.forEach(period => {
        this.periodList.push(period);
      });
    },
    setCurrentBreakTimePeriod(breakTimePeriods) {
      this.breakTimePeriodList.splice(0);
      breakTimePeriods.forEach(breakTimePeriod => {
        this.breakTimePeriodList.push(breakTimePeriod);
      });
    },
    handleChange(e) {
      // 24時間チェックを非表示にするため、以下を一時的にコメントアウト
      // this.$emit('update:is24hours', this.currentIs24hours);
      this.$emit('update:periods', cloneDeep(this.periodList));
      this.$emit('change', e);
    },
    handleBreakTimeChange(e) {
      this.$emit('update:breakTimePeriods', cloneDeep(this.breakTimePeriodList));
      this.$emit('breakTimeChange', e);
    },
    convertIndex(index) {
      return index ? index.toString() : '';
    },
  },
};
</script>
